<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M4.75 24.1071V13.8929C4.75 13.3406 5.19772 12.8929 5.75 12.8929H12.5421C12.7691 12.8929 12.9895 12.8156 13.1668 12.6737L21.4467 6.04976C22.1015 5.52595 23.0714 5.99212 23.0714 6.83063V31.1694C23.0714 32.0079 22.1015 32.4741 21.4467 31.9502L13.1668 25.3263C12.9895 25.1844 12.7691 25.1071 12.5421 25.1071H5.75C5.19772 25.1071 4.75 24.6594 4.75 24.1071Z"
			:fill="props.iconColor"
		/>
		<circle cx="26.9154" cy="15.8333" r="1.58333" fill="white" />
		<ellipse cx="27.146" cy="21.865" rx="1.58333" ry="1.58333" transform="rotate(75 27.146 21.865)" fill="white" />
		<ellipse cx="31.6654" cy="12.6673" rx="1.58333" ry="1.58333" fill="white" />
		<ellipse cx="31.4351" cy="25.6345" rx="1.58333" ry="1.58333" transform="rotate(75 31.4351 25.6345)" fill="white" />
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 38,
		height: 38,
		iconColor: '#818393',
	}
);
</script>

<style lang="scss" scoped></style>
